export default __webpack_public_path__ + "atomic/_patterns/02-molecules/language-switcher/_language-switcher.twig";